const confirmingData = {
  name: 'confirming',
  titleText: '¿Quieres pagar a tus proveedores sin descapitalizarte?',
  subtitleText: 'Con Confirming de Fingo nosotros pagamos por ti y les aseguras el dinero a tiempo, mientras tú ganas más plazo para pagar.',
  startTextButton: 'Realizar Confirming',
  hero_image: '/images/confirming_hero.webp',
  description_information: {
    image: '/images/confirming_description.webp',
    title: '¿Qué es el Confirming?',
    text: 'Confirming es un servicio financiero que permite a las empresas gestionar y financiar el pago a sus proveedores de manera más flexible.'
    + 'En lugar de que la empresa pague directamente al proveedores en la fecha original, Fingo gestiona ese pago y ofrece la posibilidad de extender el plazo para que la empresa pueda aplazar el pago, '
    + 'pagando intereses por esa extensión, mientras el proveedor recibe el pago puntual.',
  },
  benefits_information: {
    image: '/images/confirming_benefits.webp',
    title: 'Beneficios de operar con Fingo',
    text: [
      'Proceso digital, seguro y transparente con respaldo de Fingo.',
      'Extiende tus plazos de pago sin afectar a tus proveedores.',
      'Garantiza que tus proveedores reciban el pago en la fecha original.',
      'Mejora tu flujo de caja y planificación financiera.',
      'Soporte y acompañamiento personalizado durante todo el proceso.',
    ],
  },
};

export default confirmingData;
